var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.72082C11 5.29039 10.7246 4.90825 10.3162 4.77214L3.31623 2.4388C2.66869 2.22296 2 2.70493 2 3.38749V21.2501C1.58579 21.2501 1.25 21.5859 1.25 22.0001C1.25 22.4143 1.58579 22.7501 2 22.7501H22C22.4142 22.7501 22.75 22.4143 22.75 22.0001C22.75 21.5859 22.4142 21.2501 22 21.2501V8.28084C22 7.63026 21.3886 7.15291 20.7575 7.31069L13.7575 9.06069C13.3123 9.17198 13 9.57197 13 10.0309V21.2501H11V5.72082Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseAlt3);
export default __webpack_public_path__ + "static/media/house-alt-3.361aae5bee77d9daad2ba2470819fdc1.svg";
export { ForwardRef as ReactComponent };